import { useTranslation } from 'react-i18next';
import './GestureDemos.css';

// A real nightstand sprite, so the demos look like the game, not a diagram.
const DEMO_ITEM_SRC = '/game-assets/interior/8.webp';

/**
 * Looping demo: a finger taps the build-mode switch (top right in the room) — it
 * turns on and the furniture buttons appear. Build mode is off on every entry.
 */
export function BuildModeDemo() {
  // "Inventory" / "Shop" stay literal: the room's own buttons are untranslated.
  return (
    <div className="gesture-demo gesture-demo--build" aria-hidden="true">
      <div className="gesture-demo__floor" />
      <img className="gesture-demo__item" src={DEMO_ITEM_SRC} alt="" />
      <div className="gesture-demo__switch">
        <img className="gesture-demo__switch-icon" src="/ui/icons/build-mode-icon.png" alt="" />
        <div className="gesture-demo__switch-track">
          <div className="gesture-demo__switch-knob" />
        </div>
      </div>
      <div className="gesture-demo__ripple" />
      <div className="gesture-demo__finger" />
      <div className="gesture-demo__button gesture-demo__button--left">Inventory</div>
      <div className="gesture-demo__button gesture-demo__button--right">Shop</div>
    </div>
  );
}

/** Looping demo: a finger taps a piece of furniture → its settings menu opens. */
export function TapMenuDemo() {
  const { t } = useTranslation();
  return (
    <div className="gesture-demo gesture-demo--tap" aria-hidden="true">
      <div className="gesture-demo__floor" />
      <div className="gesture-demo__outline" />
      <img className="gesture-demo__item" src={DEMO_ITEM_SRC} alt="" />
      <div className="gesture-demo__pill gesture-demo__pill--top">{t("Flip")}</div>
      <div className="gesture-demo__pill gesture-demo__pill--bottom">{t("Hide")}</div>
      <div className="gesture-demo__ripple" />
      <div className="gesture-demo__finger" />
    </div>
  );
}

/** Looping demo: a finger drags furniture; it rides above the finger over a landing zone. */
export function DragDemo() {
  return (
    <div className="gesture-demo gesture-demo--drag" aria-hidden="true">
      <div className="gesture-demo__floor" />
      <div className="gesture-demo__mover">
        <div className="gesture-demo__zone" />
        <img className="gesture-demo__item" src={DEMO_ITEM_SRC} alt="" />
        <div className="gesture-demo__finger" />
      </div>
    </div>
  );
}
